// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Reprocessos_UploadPhotoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/reprocessos/upload_photo
 *
 * Validates input for uploading a reprocesso photo (before or after).
 * Multipart form: photo (file).
 */
import { registerContract } from './validate'

export interface Reprocessos_UploadPhotoInput {
_files: unknown[]
}

registerContract('Reprocessos_UploadPhotoInput', {
  _files: { type: 'array',   required: true },
})
